export const QUICK_CHECKOUT_DEFAULT_METHOD = 'checkout';

export const RECENT_PDP_URL = 'recentPdpUrl';
export const PDP_SCROLL_TO_BOTTOM = 'PDPScrollToBottom';
